import React from 'react';
const STATS = [{
  value: '17 años',
  label: 'De experiencia en el ecosistema Apple'
}, {
  value: '+8.500',
  label: 'Equipos Apple vendidos y configurados'
}, {
  value: '1 + 5',
  label: 'Libro principal y bonos incluidos'
}, {
  value: 'Todos',
  label: 'Los modelos con iOS actual'
}];
export function StatsBar() {
  return <section aria-label="Cifras principales" className="w-full border-y border-white/10 bg-gold px-5 py-8 sm:px-8" data-id="element-258" data-mp="1jbiu1snoqy4c">
      <dl className="mx-auto grid w-full max-w-5xl gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-259" data-mp="1eeip5l2ko1et">
        {STATS.map(stat => <div key={stat.value} className="text-center lg:text-left" data-id="element-260" data-mp="19keh0yhklnc5">
            <dt className="text-2xl font-extrabold tracking-tight text-ink-950 sm:text-3xl" data-id="element-261" data-mp="15lp6ddnx2jw7">
              {stat.value}
            </dt>
            <dd className="mt-1 text-xs font-medium leading-relaxed text-ink-950/70 sm:text-sm" data-id="element-262" data-mp="10jzszrd81u4y">
              {stat.label}
            </dd>
          </div>)}
      </dl>
    </section>;
}